import { render, staticRenderFns } from "./GetStarted.vue?vue&type=template&id=4b5b520c&scoped=true"
import script from "./GetStarted.vue?vue&type=script&lang=js"
export * from "./GetStarted.vue?vue&type=script&lang=js"
import style0 from "./GetStarted.vue?vue&type=style&index=0&id=4b5b520c&prod&lang=scss&scoped=true"
import style1 from "./GetStarted.vue?vue&type=style&index=1&id=4b5b520c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b5b520c",
  null
  
)

export default component.exports